import { Directive } from '@angular/core';

@Directive({
  selector: 'wchfs-label',
})
export class Label {}
